import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'dayFilter',
    standalone: false
})

export class DayFilterPipe implements PipeTransform {
    transform(items: any[], searchDate: Date): any[] {
        if (!items) return [];
        if (!searchDate) return items;

        return items.filter(it => {
            return this.isMatchingDate(it.PubDate, searchDate)
        });

    }

    private isMatchingDate(dateOne: Date, dateTwo: Date): Boolean {
        if (dateOne && dateTwo) {
            //set the times to be the same as we are just comparing dates
            let dateA = new Date(dateOne).setHours(0, 0, 0, 0);
            let dateB = new Date(dateTwo).setHours(0, 0, 0, 0);            
            if (dateA.valueOf() == dateB.valueOf()) {
                return true;
            }
        }
        return false;
    }

}
